import { useState } from 'react';
import { hooks as commonHooks } from '@sitebuilder/common';
import TableRow from './TableRow';
import { ColumnOption, SelectionListData } from './CustomizedFundList';

interface PropsShape {
    columns: ColumnOption[];
    data: any;
    widgetInstance: any;
    enableWatchlist: boolean;
    watchlist: string[];
    setWatchlist: (checklist: string[]) => void;
    watchlistStorageName?: string;
    watchlistDataId?: string;
    addToWatchlistText: string;
    removeFromWatchlistText: string;
    index: number;
    label: string;
    rows: any[];
    groupsCount: Record<string, number>;
    showGroupingCount: boolean;
    isCollapseRowGroup: boolean;
    showRowGroupIconName: string;
    hideRowGroupIconName: string;
    isMobile: boolean;
    onChangeSelectionLists: (data: Record<string, string[]>) => any;
    selectionLists: Record<string, string[]>;
    filterBySelection: SelectionListData[];
    onClickCompare: (storageName: string, id: string, colId: string, changeToTab?: string) => any;
    onTriggerTracking: (
        event: string,
        currentTab?: string,
        fundName?: string,
        filterAnalyticLabel?: string,
        customValue?: string
    ) => any;
    staticDataTabIndex: number;
    useAnalytics: boolean;
    selectedTab?: string;
}

export default function TableRowGroup(props: PropsShape) {
    const {
        label,
        columns,
        rows,
        data,
        widgetInstance,
        setWatchlist,
        watchlist,
        watchlistDataId,
        index,
        ...rest
    } = props;

    const i18n = commonHooks.useLocalization();

    const [isExpanded, setIsExpanded] = useState(true);
    const toggleGroup = () => setIsExpanded(!isExpanded);

    // Compose toggle classes and labels
    let toggleClassName = 'row-group-toggle-icon ';
    let toggleLabel;

    if (isExpanded) {
        toggleClassName += rest.hideRowGroupIconName;
        toggleLabel = i18n.t('widgets_fundList_rowGroups_collapse');
    } else {
        toggleClassName += rest.showRowGroupIconName;
        toggleLabel = i18n.t('widgets_fundList_rowGroups_expand');
    }

    return (
        <>
            {rest.isMobile ? (
                <tr data-group-id={index} className="row--group" key={index}>
                    <td colSpan={columns.length + 1}>
                        <button
                            className={`icon-button row-group-toggle ${
                                rest.isCollapseRowGroup ? '' : 'notToggable'
                            }`}
                            type="button"
                            onClick={() => (rest.isCollapseRowGroup ? toggleGroup() : null)}
                            tabIndex={rest.isCollapseRowGroup ? 0 : -1}
                        >
                            <i className={toggleClassName} />
                            {label}{' '}
                            {rest.showGroupingCount ? (
                                // eslint-disable-next-line max-len
                                <span className="row-group-count">{`${rest.groupsCount[label]}`}</span>
                            ) : (
                                ''
                            )}
                            <span className="sr-only">{toggleLabel}</span>
                        </button>
                    </td>
                </tr>
            ) : (
                <div
                    className={`card row-group-container ${rest.selectedTab}`}
                    key={index}
                    data-group-id={index}
                >
                    <div className="card-row row--group">
                        <div className="left">
                            <button
                                className={`icon-button row-group-toggle ${
                                    rest.isCollapseRowGroup ? '' : 'notToggable'
                                }`}
                                type="button"
                                onClick={() => (rest.isCollapseRowGroup ? toggleGroup() : null)}
                            >
                                <i className={toggleClassName} />
                                {label}{' '}
                                {rest.showGroupingCount ? (
                                    // eslint-disable-next-line max-len
                                    <span className="row-group-count">{`${rest.groupsCount[label]}`}</span>
                                ) : (
                                    ''
                                )}
                                <span className="sr-only">{toggleLabel}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {isExpanded
                ? rows.map((r, ind) => (
                      <TableRow
                          data={data}
                          columns={columns}
                          widgetInstance={widgetInstance}
                          enableWatchlist={rest.enableWatchlist}
                          setWatchlist={setWatchlist}
                          watchlistStorageName={rest.watchlistStorageName}
                          watchlistDataId={watchlistDataId}
                          addToWatchlistText={rest.addToWatchlistText}
                          removeFromWatchlistText={rest.removeFromWatchlistText}
                          watchlist={watchlist}
                          r={r}
                          index={ind}
                          isMobile={rest.isMobile}
                          onChangeSelectionLists={rest.onChangeSelectionLists}
                          selectionLists={rest.selectionLists}
                          filterBySelection={rest.filterBySelection}
                          onClickCompare={rest.onClickCompare}
                          onTriggerTracking={rest.onTriggerTracking}
                          key={ind}
                          staticDataTabIndex={rest.staticDataTabIndex}
                          useAnalytics={rest.useAnalytics}
                          selectedTab={rest.selectedTab || ''}
                      />
                  ))
                : null}
        </>
    );
}
